import PMI from "../../../container/DigitalDashboard/pmi/data/pmi.json";
import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";
const digitalDashboardApi = {
  // `options.silent` is for reads the app makes on its own behalf (resolving
  // the Business -> Region mapping asks this endpoint once per business).
  getFilters: (payload, options = {}) => {
    const url=`pmi/dashboard_data`
    return request({
      method: HTTP_METHOD.POST,
      url,
      data:payload,
      silent: !!options.silent
    });
  },
  getDashboardQuery:(payload)=>{
    const url=`pmi/dashboard_data`
     return request({
      method: HTTP_METHOD.POST,
      url,
      data:payload
    });
  },
  getDashboardQuerySales:(payload)=>{
    const url=`pmi/dashboard_data_v2`
     return request({
      method: HTTP_METHOD.POST,
      url,
      data:payload
    });
  },
  getHdArticlesInventory:(payload)=>{
    const url=`pmi/hd_articles_inventory`
     return request({
      method: HTTP_METHOD.POST,
      url,
      data:payload
    });
  },
  searchSalesOrder:(payload)=>{
    const url=`so_search_sales_order`
     return request({
      method: HTTP_METHOD.POST,
      url,
      data:payload,
      silent: true
    });
  }

};

export default digitalDashboardApi;
